<template>
  <div class="wrapper">
    <!-- v-loading.fullscreen="loading" -->
    <div class="bgc">
      <div class="shop-container">
        <div class="nav-bread">
          <router-link to="/">{{ $t("home") }}</router-link>
          <span>></span>
          <router-link :to="{ name: 'gamelist' }">{{ "竞技赛事" }}</router-link>
          <span>></span>
          <router-link :to="{ name: 'gamedetail' }">{{ "赛事详情" }}</router-link>
          <span>></span>
          <span>{{ "淘汰赛" }}</span>
        </div>
      </div>
    </div>
    <div class="main bgw" style="background-color: rgba(250, 250, 250, 1)">
      <div class="shop-container">
        <div class="tabs">
          <el-select v-model="select1" placeholder="请选择" @change="changeSelect1($event)" style="margin-right: 20px;">
            <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
              <span style="float: left">{{ item.label }}</span>
            </el-option>
          </el-select>
          <el-button type="primary" :loading="loading" @click="refreash()">刷新</el-button>
        </div>
        <div style="margin-bottom: 20px; background-color: white" v-loading="loading">
          <eliminationSeries
            v-if="seriesData.length > 0 && seriesData[0] && seriesData[0].list && seriesData[0].list.length > 0"
            :series-data="seriesData"
            :unitType="unitType"
            @toRedit1="toRedit1"
          ></eliminationSeries>
          <div v-else style="text-align: center; margin-top: 20px; padding: 20px">
            <!-- <img src="@/assets/images/nodata.png" style="width: 100px; height: 100px" /> -->
            <p style="font-size: 20px; margin-top: 20px">{{ $t("noData") }}</p>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="showDescript" width="50%" :before-close="handleClose">
      <div style="padding: 25px; display: flex; justify-content: center; align-items: center; flex-direction: column">
        <div class="card">
          <div class="card_body">
            <div class="userInfo">
              <div class="flex-t">
                <img v-if="team1.cover" :src="team1.cover" mode="scaleToFill" />
                <img v-else src="@/assets/images/avatar-default.png" mode="scaleToFill" />
                <div class="content">
                  <div class="title">
                    {{ team1.nickname }}
                  </div>
                </div>
              </div>
              <div class="vs">{{ teamGrade1 }} - {{ teamGrade2 }}</div>
              <div class="flex-t">
                <img v-if="team2.cover" :src="team2.cover" mode="scaleToFill" />
                <img v-else src="@/assets/images/avatar-default.png" mode="scaleToFill" />
                <div class="content">
                  <div class="title">
                    {{ team2.nickname }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-table :data="tableDataDetail" border style="width: 100%">
          <el-table-column label="每箭环数" width="180">
            <template slot-scope="scope">
              <span class="small_default_btn" v-show="scope.row[1].result[1]">{{ scope.row[1].result[1] }}</span>
              <span class="small_default_btn" v-show="scope.row[1].result[2]">{{ scope.row[1].result[2] }}</span>
              <span class="small_default_btn" v-show="scope.row[1].result[3]">{{ scope.row[1].result[3] }}</span>
              <span class="small_default_btn" v-show="scope.row[1].result[4]">{{ scope.row[1].result[4] }}</span>
              <span class="small_default_btn" v-show="scope.row[1].result[5]">{{ scope.row[1].result[5] }}</span>
              <span class="small_default_btn" v-show="scope.row[1].result[6]">{{ scope.row[1].result[6] }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="组分">
            <template slot-scope="scope">
              <span class="small_default_btn">{{
                grades([
                  scope.row[1].result[1],
                  scope.row[1].result[2],
                  scope.row[1].result[3],
                  scope.row[1].result[4],
                  scope.row[1].result[5],
                  scope.row[1].result[6],
                ])
              }}</span></template
            >
          </el-table-column>
          <el-table-column prop="result_total" label="局分" width="120">
            <template slot-scope="scope"
              ><span class="small_default_btn red">{{ getDivision(scope.row[1].division) }}</span>
              <span class="small_default_btn red">{{ getDivision(scope.row[2].division) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="组分">
            <template slot-scope="scope">
              <span class="small_default_btn">{{
                grades([
                  scope.row[2].result[1],
                  scope.row[2].result[2],
                  scope.row[2].result[3],
                  scope.row[2].result[4],
                  scope.row[2].result[5],
                  scope.row[2].result[6],
                ])
              }}</span></template
            >
          </el-table-column>
          <el-table-column label="每箭环数" width="180">
            <template slot-scope="scope">
              <span class="small_default_btn" v-show="scope.row[2].result[1]">{{ scope.row[2].result[1] }}</span>
              <span class="small_default_btn" v-show="scope.row[2].result[2]">{{ scope.row[2].result[2] }}</span>
              <span class="small_default_btn" v-show="scope.row[2].result[3]">{{ scope.row[2].result[3] }}</span>
              <span class="small_default_btn" v-show="scope.row[2].result[4]">{{ scope.row[2].result[4] }}</span>
              <span class="small_default_btn" v-show="scope.row[2].result[5]">{{ scope.row[2].result[5] }}</span>
              <span class="small_default_btn" v-show="scope.row[2].result[6]">{{ scope.row[2].result[6] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import eliminationSeries from "@/components/elimination-series.vue";
export default {
  components: { eliminationSeries },
  data() {
    return {
      loading:false,
      gameId: "game",
      select1: "",
      options1: [],
      tableData: [],
      getData: [],
      distance_num: "",
      currentRow: "",
      showDescript: false,
      dialogTitle: "详情",
      tableDataDetail: [],
      seriesData: [],
      unitType: "",
      teamGrade1: "",
      teamGrade2: "",
      team1: {},
      team2: {},
    };
  },
  mounted() {
    this.gameId = this.$route.params.gameId;
    this.startClass();
  },
  computed: {
    
    grades(arr) {
      return (arr) => {
        let num = 0;
        arr.forEach((e) => {
          if (e == "X") {
            num += 10;
          } else if (e == "M" || e == "" || e == null || e == undefined) {
            num += 0;
          } else {
            num += e * 1;
          }
        });
        return num;
      };
    },
    getDivision(number) {
      return (number) => {
        if (number == "M") {
          number = 0;
        } else if (number == "X") {
          number = 10;
        } else if (!number) {
          number = 0;
        }
        return number;
      };
    },
  },
  methods: {
    refreash(){
      this.ranking()
    },
    handleClose() {
      this.showDescript = false;
    },

    changeSelect1(e) {
      this.select1 = e;
      this.ranking();
    },
    // 获取select数据
    startClass() {
      this.$api
        .gatallProject({
          plan_id: this.gameId,
          game_style: 2,
        })
        .then((res) => {
          if (res.status) {
            if (res.data && res.data.length > 0) {
              var arr = res.data;
              this.options1 = arr.map((r) => {
                return {
                  label: r.name,
                  value: r.ids,
                };
              });
              this.select1 = this.options1[0].value;
              this.ranking();
            }
          } else {
            this.$common.errorToShow(res.msg);
          }
        });
    },
    // 根据select获取数据
    ranking() {
      this.loading = true;
      this.$api
        .getallRanking({
          ids: this.select1,
        })
        .then((res) => {
          if (res.status) {
            if (!res.data) {
              this.tableData = [];
              this.getData = [];
            } else {
              this.getData = res.data;
              let length = res.data.length;
              var type = res.data[length - 1].game_round;
              this.showType(type);
              // console.log(type);
            }
          } else {
            this.$common.errorToShow(res.msg);
          }
        });
    },
    // 根据game_round确定数据的样式
    showType(e) {
      if (e == 1) {
        return "第一轮";
      } else if (e == 2) {
        this.unitType = "unit24";
        this.addLength(8); //1/32后直接跟1/16，只有这个特殊不按顺序来
      } else if (e == 3) {
        this.unitType = "unit48";
        this.addLength(9); //1/48后直接跟1/24
      } else if (e == 4) {
        this.unitType = "unit24";
        this.addLength(8);
      } else if (e == 5) {
        this.unitType = "unit16";
        this.addLength(7);
      } else if (e == 6) {
        this.unitType = "unit12";
        this.addLength(6);
      } else if (e == 7) {
        this.unitType = "unit8";
        this.addLength(5);
      } else if (e == 8) {
        this.unitType = "unit4";
        this.addLength(4);
      } else if (e == 9) {
        this.unitType = "unit-half";
        this.addLength(3);
      } else if (e == 10) {
        return "铜牌决赛";
      } else if (e == 11) {
        return "金牌决赛";
      } else {
        return "";
      }
    },
    // arrLength：应该有几组数据
    addLength(arrLength) {
      this.seriesData = [];
      if (this.getData.length < arrLength) {
        let add = arrLength - this.getData.length;
        for (var i = 0; i < add; i++) {
          this.seriesData.push({});
        }
        this.getData.forEach((item) => {
          this.seriesData.unshift(item);
        });
      } else {
        this.getData.forEach((item) => {
          this.seriesData.unshift(item);
        });
      }
      this.loading=false
      // console.log(this.seriesData, "-------");
    },
    toRedit1(obj) {
      this.tableDataDetail = [];
      let data = obj.arr;
      // console.log(data, "-------");

      let params = {
        result: {
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
        },
        result_total: 0,
        result_ten: 0,
        result_x: 0,
        division: 0,
      };
      let params1 = data[0].params;
      let params2 = data[1].params;
      let max = 1;
      if (!params1 && !params2) {
        params1 = [];
        params2 = [];
        this.tableDataDetail = [];
      }
      if (params1 && !params2) {
        max = params1.length;
        for (var i = 0; i < max; i++) {
          params2.push(params);
        }
        params1.forEach((e, i) => {
          params2.forEach((e1, i1) => {
            if (i == i1) {
              this.tableDataDetail.push({ 1: e, 2: e1 });
            }
          });
        });
      }
      if (!params1 && params2) {
        max = params2.length;
        for (var i = 0; i < max; i++) {
          params1.push(params);
        }
        params1.forEach((e, i) => {
          params2.forEach((e1, i1) => {
            if (i == i1) {
              this.tableDataDetail.push({ 1: e, 2: e1 });
            }
          });
        });
      }
      if (params1 && params2) {
        max = Math.max(params1.length, params2.length);
        if (params1.length !== max) {
          for (var i = 0; i < max - params1.length; i++) {
            params1.push(params);
          }
        }
        if (params2.length !== max) {
          for (var i = 0; i < max - params2.length; i++) {
            params2.push(params);
          }
        }
        params1.forEach((e, i) => {
          params2.forEach((e1, i1) => {
            if (i == i1) {
              this.tableDataDetail.push({ 1: e, 2: e1 });
            }
          });
        });
      }

      this.team1 = data[0];
      this.team2 = data[1];
      this.teamGrade1 = 0;
      this.teamGrade2 = 0;
      if (params1 && params2) {
        params1.forEach((e) => {
          this.teamGrade1 += Number(this.getDivision(e.division));
        });
        params2.forEach((e) => {
          this.teamGrade2 += Number(this.getDivision(e.division));
        });
      }
      this.showDescript = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  .main {
    padding-top: 14px;

    .tabs {
      width: 100%;
      height: 80px;
      background: white;
      margin-bottom: 20px;
      padding: 14px 10px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      box-sizing: border-box;
    }
  }
}
.small_default_btn {
  display: inline-block;
  width: 42px !important;
  height: 24px !important;
  margin-right: 6px !important;
  text-align: center;
  background: rgba(250, 250, 250, 1);
}
.red {
  color: red;
}
.userInfo {
  // width: 670rpx;
  width: 100%;
  // height: 120rpx;
  display: flex;
  justify-content: space-around;
  align-items: center;

  .flex-t {
    width: 39%;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      // margin-right: 20rpx;
      box-shadow: 0px 0px 1px 1px rgba(0, 0, 0, 0.1);
    }

    .content {
      width: 100%;
      // height: 120rpx;

      .title {
        position: relative;
        min-height: 22px;
        line-height: 22px;
        font-size: 14px;
        font-weight: 700;
        color: rgb(10, 33, 51);
        margin-top: 6px;
        margin-bottom: 9px;
        text-align: center;
        .icon {
          position: absolute;
          top: 10%;
          right: 10px;
        }
      }

      .title-desc {
        position: relative;
        height: 17px;
        line-height: 17px;
        font-size: 14px;
        color: rgb(108, 122, 133);
        text-align: center;
        margin-bottom: 6px;
      }
      .icon-edit {
        position: relative;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;

        .text-style {
          width: 42%;
          font-size: 12px;
          color: #ff4d40;
          border-radius: 5px;
          border: 2rpx solid #ff4d40;
        }
        .icon {
          // position: absolute;
          // top: 10%;
          // right: 10px;
        }
      }
    }
  }

  .vs {
    font-size: 20px;
    color: #05111a;
    min-width: 22%;
    text-align: center;
    white-space: nowrap;
  }
}
.card {
  width: 80%;
  padding: 26px 20px 23px;
  margin: 0 0 20px;
  background: #ffffff;
  .card_body {
  }
}
</style>
